import axios from 'axios'

export const Number = {
  methods: {
    getInt (val, nanVal = '/') {
      return isNaN(parseInt(val, 10)) ? nanVal : parseInt(val, 10)
    }
  }
}

export const Browser = {
  methods: {
    copyToClipboard (text, displayToast = false) {
      navigator.clipboard.writeText(text)
      if (displayToast) {
        this.$toastr.success('Value copied!')
      }
    },
    downloadFile (name, content) {
      const url = window.URL.createObjectURL(new Blob([content]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', name)
      document.body.appendChild(link)
      link.click()
    }
  },
  uploadFile (selector, url) {
    let formData = new FormData()
    let file = document.querySelector(selector)
    formData.append('file', file.files[0])
    return axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

export const Values = {
  methods: {
    getVal (value, def = '/') {
      return typeof value !== 'undefined' ? value : def
    },
    shorten (value, maxLength = 20) {
      if (value) {
        return value.length <= maxLength ? value : value.substring(0, maxLength) + '...'
      } else {
        return ''
      }
    }
  }
}

export const String = {
  methods: {
    ucFirst (val) {
      return val.charAt(0).toUpperCase() + val.slice(1)
    },
    shorten (val, length = 50, defaultText = '', appendix = '...') {
      if (!val) {
        return defaultText
      }
      return val.substring(0, length) + (val.length > length ? appendix : '')
    }
  }
}

export const Query = {
  methods: {
    buildQuery (filters, multiFilters = []) {
      let query = ''
      if (Object.entries(multiFilters).length) {
        Object.entries(multiFilters).forEach((data) => {
          filters[data[0]] = data[1].map(c => c.id)
        })
      }

      let objQuery = ''

      Object.keys(filters).forEach(f => {
        if (filters[f] === '' || filters[f] === null) {
          delete filters[f]
        }
        if (typeof filters[f] === 'object' && !Array.isArray(filters[f])) {
          objQuery += Object.keys(filters[f]).map(k => `${f}[${k}]=${filters[f][k]}`).join('&')
        }
      })

      query += '&' + Object.keys(filters).map(key => `${key}=${filters[key]}`).join('&')
      query += '&' + objQuery
      return query
    }
  }
}

export const FormValidation = {
  methods: {
    mandatoryData (fields, data) {
      let missing = []
      fields.forEach(f => {
        if (!data[f]) {
          missing.push(f)
        }
      })

      return missing.length === 0 ? true : missing
    },
    isUrl (url) {
      return /^(?:https?:\/\/)?(?:www\.)?[^\s.]+\.[^\s]{2,}$/i.test(url.trim())
    },
    isEmail (email) {
      return /^[a-zA-Z0-9_.]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(email.trim())
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/helperMixin.js